module.exports = __webpack_public_path__ + "static/media/bluesky-brands-solid-full.500c5f93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bluesky-brands-solid-full.svg
// module id = 229
// module chunks = 0